<mat-nav-list>
  <a
    mat-list-item
    [routerLink]="[Paths.ADMIN_COCKPIT_PATH, Paths.PENTEST_CALENDAR_PATH]"
    routerLinkActive
    #pentestCalendarRla="routerLinkActive"
    [activated]="pentestCalendarRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.pentestCalendar' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="calendar_month" />
    <span>{{ 'navbar.pentestCalendar' | translate }}</span>
  </a>
  <a
    mat-list-item
    [routerLink]="[Paths.ADMIN_COCKPIT_PATH, Paths.CUSTOMERS_PATH]"
    routerLinkActive
    #customersRla="routerLinkActive"
    [activated]="customersRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.customers' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="domain" />
    <span>{{ 'navbar.customers' | translate }}</span>
  </a>
  <a
    mat-list-item
    [routerLink]="[Paths.ADMIN_COCKPIT_PATH, Paths.PARTNERS_PATH]"
    routerLinkActive
    #partnersRla="routerLinkActive"
    [activated]="partnersRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.partners' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="handshake" />
    <span>{{ 'navbar.partners' | translate }}</span>
  </a>
  <a
    mat-list-item
    [routerLink]="[Paths.ADMIN_COCKPIT_PATH, Paths.USERS_PATH]"
    routerLinkActive
    #usersRla="routerLinkActive"
    [activated]="usersRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.users' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="groups" />
    <span>{{ 'navbar.users' | translate }}</span>
  </a>
  <a
    mat-list-item
    [routerLink]="[Paths.ADMIN_COCKPIT_PATH, Paths.BOXES_PATH]"
    routerLinkActive
    #boxesRla="routerLinkActive"
    [activated]="boxesRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.boxes' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="router" />
    <span>{{ 'navbar.boxes' | translate }}</span>
  </a>
</mat-nav-list>
